export default __webpack_public_path__ + "static/IMG_9205-c3623ea0979226bcedc51ba029f89aa2.jpg";